function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  id: "style2",
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:0.9335;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:0.9335;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-239.22299,-345.76001)",
  className: "st0",
  id: "Layer_1"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-239.22299,-345.76001)",
  id: "Layer_2"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle7",
  r: 53.369999,
  cy: 399.13,
  cx: 334.53
}), /*#__PURE__*/React.createElement("path", {
  id: "path9",
  d: "m 359.2,420.17 c 0,5.16 -11.04,15.26 -24.67,15.26 -13.62,0 -24.67,-6.83 -24.67,-15.26 z",
  className: "st1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path11",
  d: "m 428.47,513.11 -18.2,14.56 -12.03,-11.83 c 0,0 0,0 -3.34,-2.93 -3.34,-2.93 -9.81,-1.11 -9.81,-1.11 l -12.76,12.44 c -3.37,7.01 1.35,12 2.56,13.62 1.21,1.62 9.3,9.84 9.3,9.84 l -22.52,2.83 c -92.22,9.17 -122.43,-17.26 -122.43,-17.26 -1.08,-77.74 49.62,-73.76 49.62,-73.76 0,0 37.21,33.56 88.45,0 0,0 33.98,-1.2 46.92,34.39 l 3.78,16.72 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path13",
  d: "M 406.93,558.42",
  className: "st2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path15",
  d: "m 438.95,575.22 -4.63,4.57 c -1.39,1.37 -3.63,1.32 -4.95,-0.12 l -20.44,-22.25 -20.36,20.36 c -1.29,1.29 -3.36,1.35 -4.72,0.14 l -5.35,-4.76 c -1.51,-1.34 -1.54,-3.69 -0.07,-5.08 L 398.81,548.92 381,531.63 c -1.33,-1.29 -1.38,-3.41 -0.11,-4.76 l 5.48,-5.81 c 1.29,-1.37 3.44,-1.42 4.8,-0.13 l 18.16,17.27 20.2,-16.11 c 1.56,-1.25 3.83,-1.05 5.14,0.45 l 4.49,5.1 c 1.39,1.58 1.21,3.98 -0.4,5.34 l -19.58,16.48 19.84,20.94 c 1.3,1.36 1.27,3.5 -0.07,4.82 z",
  className: "st3"
}));

var SvgNotVerifiedUser = function SvgNotVerifiedUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 235",
    style: {
      enableBackground: "new 0 0 200 235"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotVerifiedUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NotVerifiedUser.2e2e8a1e.svg";
export { ForwardRef as ReactComponent };